import { Link as JuicyLink } from '@vtbhome/juicyfront';
import { BREAKPOINTS } from '../../../shared/config/breakpoints/breakpoints';
import { COLORS, hexToRGB } from '../../../shared/config/colors/colors';
import { styled } from 'goober';
import { LinkScroll } from '@shared/ui/link-scroll/link-scroll';

export const Wrapper = styled('header')`
    position: sticky;
    width: 100%;
    top: 0;
    box-shadow:
        0 0 1px ${hexToRGB(COLORS.black, 0.04)},
        0 0 2px ${hexToRGB(COLORS.black, 0.06)},
        0 4px 8px ${hexToRGB(COLORS.black, 0.04)};
    z-index: 100;
    background-color: ${COLORS.neutral_00};
`;

export const SizeContainer = styled('div')`
    display: flex;
    width: 100%;
    max-width: 1440px;
    margin: 0 auto;
    padding: 16px 32px 16px 24px;
    gap: 20px;
    align-items: center;
`;

export const LogoLink = styled(LinkScroll)`
    display: flex;
    align-items: center;
`;

export const FinderWrapper = styled('div')`
    display: flex;
    align-items: center;
    flex-grow: 1;

    .rf-search {
        position: relative;
        max-width: 480px;
        min-width: 150px;
    }

    @media all and (min-width: ${BREAKPOINTS.DESKTOP_M}px) {
        .rf-search {
            position: relative;
            width: 80%;
            left: calc(50vw - 152px);
            transform: translateX(-50%);
        }
    }

    @media all and (min-width: ${BREAKPOINTS.DESKTOP_L}px) {
        .rf-search {
            left: 563px;
        }
    }
`;

export const Controls = styled('div')`
    display: flex;
    align-items: center;
    gap: 14px;
`;

export const SupportTooltipBody = styled('div')`
    display: flex;
    gap: 16px;
    flex-direction: column;
`;

export const SupportTooltipText = styled('div')`
    display: flex;
    gap: 4px;
    flex-direction: column;
`;

export const PhoneContact = styled('div')`
    display: flex;
`;

export const PhoneLink = styled(JuicyLink)`
    line-height: 16px !important;
`;
